import { useLocation, useNavigate } from 'react-router-dom';

import { createTripGroup, readTripGroupPrompts } from '@api/trip_groups';
import { Breadcrumbs, Layout } from '@utilities';

import Builder from '../../components/Builder';
import Page from '../../layouts/Page';

const CreateTripGroup = () => {
  const navigate = useNavigate();
  const { search } = useLocation();

  return (
    <Page>
      <Layout.Column>
        <Breadcrumbs />
        <Builder
          create={createTripGroup}
          documentId="trip-group"
          onSubmit={() => navigate('/dashboard/workspace/trip-groups')}
          read={(serviceName) => readTripGroupPrompts({ search, serviceName, transform: false })}
          type="Trip Group"
        />
      </Layout.Column>
    </Page>
  );
};

export default CreateTripGroup;
